import { useState } from "react";
import Icon from "./Icon";
import { useUpdateCheck } from "../store/updateCheck";

// Barra persistente (no se autodescarta como un toast) para que el aviso de
// "hay versión nueva" no pase inadvertido; "Ahora no" solo la oculta en esta
// pestaña, no cancela el aviso permanentemente.
export default function UpdateBanner() {
  const ctx = useUpdateCheck();
  const [dismissed, setDismissed] = useState(false);
  if (!ctx?.available || dismissed) return null;

  return (
    <div className="fixed inset-x-0 top-0 z-[100] flex items-center justify-center gap-3 bg-brand-600 px-4 py-2 text-sm text-white shadow-md">
      <Icon name="download" size={16} />
      <span>Hay una nueva versión de la aplicación disponible.</span>
      <button
        onClick={ctx.applyUpdate}
        className="rounded-md bg-white/15 px-3 py-1 font-semibold hover:bg-white/25"
      >
        Actualizar ahora
      </button>
      <button
        onClick={() => setDismissed(true)}
        className="ml-1 opacity-70 hover:opacity-100"
        title="Ahora no"
      >
        <Icon name="x" size={14} />
      </button>
    </div>
  );
}
